import { Result } from 'antd';
import { Navigate, Route, Routes } from 'react-router-dom';
import AppLayout from './components/AppLayout';
import ProtectedRoute from './components/ProtectedRoute';
import { useAuth } from './context/AuthContext';
import { homePathForRole } from './utils/homePath';
import AuditLogPage from './pages/AuditLogPage';
import CalculatorPage from './pages/CalculatorPage';
import DashboardPage from './pages/DashboardPage';
import DealerDashboardPage from './pages/DealerDashboardPage';
import DealerDetailPage from './pages/DealerDetailPage';
import DealerPortalPage from './pages/DealerPortalPage';
import DealersPage from './pages/DealersPage';
import InvestorDetailPage from './pages/InvestorDetailPage';
import InvestorPortalPage from './pages/InvestorPortalPage';
import InvestorsPage from './pages/InvestorsPage';
import LoginPage from './pages/LoginPage';
import ReportsPage from './pages/ReportsPage';
import UsersPage from './pages/UsersPage';

const STAFF = ['Admin', 'Accountant', 'Viewer'] as const;

export default function App() {
  const { user } = useAuth();
  const home = homePathForRole(user?.role);

  return (
    <Routes>
      <Route path="/login" element={<LoginPage />} />

      <Route
        element={
          <ProtectedRoute>
            <AppLayout />
          </ProtectedRoute>
        }
      >
        <Route index element={<Navigate to={home} replace />} />

        <Route
          path="/dashboard"
          element={
            <ProtectedRoute roles={[...STAFF]}>
              <DashboardPage />
            </ProtectedRoute>
          }
        />
        <Route
          path="/investors"
          element={
            <ProtectedRoute roles={[...STAFF]}>
              <InvestorsPage />
            </ProtectedRoute>
          }
        />
        <Route
          path="/investors/:id"
          element={
            <ProtectedRoute roles={[...STAFF]}>
              <InvestorDetailPage />
            </ProtectedRoute>
          }
        />
        <Route
          path="/portal"
          element={
            <ProtectedRoute roles={['Investor']}>
              <InvestorPortalPage />
            </ProtectedRoute>
          }
        />
        {/* The admin's own outbound placements — Admin-only, matching the API. Split into a KPI
            dashboard and a list, the same way the inbound side splits into Dashboard + Investors. */}
        <Route
          path="/my-investments"
          element={
            <ProtectedRoute roles={['Admin']}>
              <DealerDashboardPage />
            </ProtectedRoute>
          }
        />
        <Route
          path="/dealers"
          element={
            <ProtectedRoute roles={['Admin']}>
              <DealersPage />
            </ProtectedRoute>
          }
        />
        <Route
          path="/dealers/:id"
          element={
            <ProtectedRoute roles={['Admin']}>
              <DealerDetailPage />
            </ProtectedRoute>
          }
        />
        <Route
          path="/dealer-portal"
          element={
            <ProtectedRoute roles={['Dealer']}>
              <DealerPortalPage />
            </ProtectedRoute>
          }
        />
        <Route
          path="/reports"
          element={
            <ProtectedRoute roles={[...STAFF]}>
              <ReportsPage />
            </ProtectedRoute>
          }
        />
        <Route
          path="/calculator"
          element={
            <ProtectedRoute>
              <CalculatorPage />
            </ProtectedRoute>
          }
        />
        <Route
          path="/users"
          element={
            <ProtectedRoute roles={['Admin']}>
              <UsersPage />
            </ProtectedRoute>
          }
        />
        <Route
          path="/audit-log"
          element={
            <ProtectedRoute roles={['Admin']}>
              <AuditLogPage />
            </ProtectedRoute>
          }
        />

        <Route path="*" element={<Result status="404" title="404" subTitle="Page not found." />} />
      </Route>
    </Routes>
  );
}
